<div>
<div [hidden]="!isLoading" style="position: fixed; width: 100%; z-index: 1000;">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div [hidden]="!isLoading" style="position: fixed; height: 100vh; width: 100%; background-color: #80808054; z-index: 100;"></div>

<app-header ></app-header>

<router-outlet></router-outlet>

<app-footer></app-footer>
</div>